<script lang="ts" setup>
import Breadcrumb from '@/Layouts/App/Components/Breadcrumb.vue'
import { useAppLayout } from '@/stores/appLayout'
import { storeToRefs } from 'pinia'
import { nextTick, onMounted, ref } from 'vue'

const { breadcrumbs } = storeToRefs(useAppLayout())
const breadcrumbsNav = ref<HTMLDivElement | null>(null)
onMounted(() => {
  nextTick(() => {
    if (breadcrumbsNav.value) {
      breadcrumbsNav.value.scrollLeft = breadcrumbsNav.value.scrollWidth
    }
  })
})
</script>

<template>
  <nav
    ref="breadcrumbsNav"
    class="flex mb-6 overflow-x-auto"
    aria-label="Breadcrumb"
  >
    <ol role="list" class="flex items-center space-x-4">
      <Breadcrumb
        v-for="(breadcrumb, index) in breadcrumbs"
        :key="index"
        :page="breadcrumb"
        :first="index === 0"
        :last="index === breadcrumbs.length - 1"
      />
    </ol>
  </nav>
</template>
